/* campaign.js — campaign page interaction + window.campaignAddItems(). */
window.campaignAddItems = async function(items){
  if(!items||!items.length) return {ok:false};
  let res,j;
  try{
    res=await fetch(window.themeVariables.routes.cartAddUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items,sections:['mini-cart']})});
    j=await res.json();
  }catch(e){
    // offline / non-JSON 5xx: surface the theme's error toast instead of failing silently
    document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show',{bubbles:true,cancelable:true,detail:{status:'error',error:''}}));
    return {ok:false};
  }
  let cart=null;   // hoisted (P2 2026-07-10): referenced by the return below; was const inside the if
  if(res.ok){
    document.documentElement.dispatchEvent(new CustomEvent('variant:added',{bubbles:true,detail:{variant:j.items?j.items[0]:j}}));
    cart=await(await fetch(window.themeVariables.routes.cartUrl+'.js')).json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart}}));
    cart.sections=j.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart,openMiniCart:window.themeVariables.settings.cartType==='drawer'}}));
  }
  document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show',{bubbles:true,cancelable:true,detail:{status:res.ok?'success':'error',error:(j&&j.description)||''}}));
  // added/cartItems/currency feed the campaign:atc value computation (P2 2026-07-10):
  // GA4 add_to_cart value must be THIS add's real charge from live cart state, never a
  // display cache. Failure path keeps all three null.
  return {ok:res.ok, added:(res.ok&&j.items)||null, cartItems:(cart&&cart.items)||null, currency:(cart&&cart.currency)||null};
};

/* campaignBusy(btn, on) — in-flight guard for Add buttons. aria-busy (not [disabled]) so the
   accessory card's sold-out [disabled] styling is never borrowed for a loading state. */
window.campaignBusy = function(btn, on){
  if (!btn) return false;
  if (on){
    if (btn.getAttribute('aria-busy') === 'true') return false;
    btn.setAttribute('aria-busy', 'true');
    return true;
  }
  btn.removeAttribute('aria-busy');
  return true;
};

/* campaignAtcValue(submitted, cartItems) — exact value of THIS add in cents, or null.
   For each submitted line ({id: variant id, quantity, properties}) find its cart line:
   variant_id must match AND properties must deep-equal the submitted ones (Shopify only
   merges identical-properties lines, so this stays unambiguous even when the same variant
   sits in the cart under a different bundle/role). Value = Σ submitted quantity × the
   line's UNIT final_price (post-discount presentment cents) — NEVER the response line's
   quantity/final_line_price, which are merged totals when the line already existed.
   cart.items (not the add.js echo) is the authority the mini-cart itself renders from.
   Any unmatched line / non-numeric price → null: omit value entirely, never 0/partial. */
window.campaignAtcValue = function(submitted, cartItems){
  if(!submitted||!submitted.length||!cartItems||!cartItems.length) return null;
  function propsKey(p){ if(!p) return '{}'; var ks=Object.keys(p).sort(), o={}, i; for(i=0;i<ks.length;i++) o[ks[i]]=String(p[ks[i]]); return JSON.stringify(o); }
  var cents=0;
  for(var i=0;i<submitted.length;i++){
    var s=submitted[i]||{}, want=String(s.id), wantProps=propsKey(s.properties), match=null;
    for(var k=0;k<cartItems.length;k++){
      var li=cartItems[k]||{};
      if(String(li.variant_id)===want && propsKey(li.properties)===wantProps){ match=li; break; }
    }
    if(!match||typeof match.final_price!=='number'||!isFinite(match.final_price)) return null;
    cents+=match.final_price*(Number(s.quantity)||1);
  }
  return (isFinite(cents)&&cents>0)?cents:null;
};

/* ── campaign-product-row custom element (Phase 3) ───────────────────────── */
(function(){
  if (typeof window === 'undefined' || !window.customElements) return;
  if (customElements.get('campaign-product-row')) return;   // double-define guard

  // money formatter: prefer the one campaign-pricing.js may expose; else minimal fallback.
  function fmtMoney(cents, fmt){
    if (typeof window.campaignFormatMoney === 'function') return window.campaignFormatMoney(cents, fmt);
    return '$' + (cents/100).toFixed(2);
  }
  function moneyFmt(){
    return (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '${{amount}}';
  }

  // ── canvas anti-scrape helpers (transcribed verbatim; local to campaign.js) ──
  var CFONT="'HarmonyOS Sans SC',-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif";
  function canvasOK(){ try{ var c=document.createElement('canvas'); return !!(c.getContext&&c.getContext('2d')); }catch(e){ return false; } }
  // canvasText(text,px,color,weight[,opts]) — renders money/text into a <canvas> so the
  // digits aren't readable in the DOM (anti-scrape). opts.strike draws a horizontal
  // line-through across the drawn glyphs (for the .was original price). Backward-compatible:
  // existing 4-arg calls (the .now price) behave exactly as before.
  function canvasText(text,px,color,weight,opts){ var dpr=Math.max(window.devicePixelRatio||1,1), c=document.createElement('canvas'), ctx=c.getContext('2d'); if(!ctx) return c;
    var font=(weight||700)+' '+px+'px '+CFONT; ctx.font=font; var textW=Math.ceil(ctx.measureText(text).width), w=textW+2, cap=Math.ceil(px*0.74), pad=Math.ceil(px*0.16), h=pad+cap+1;
    c.width=Math.ceil(w*dpr); c.height=Math.ceil(h*dpr); c.style.width=w+'px'; c.style.height=h+'px'; c.style.verticalAlign='baseline'; c.setAttribute('aria-hidden','true');
    ctx.scale(dpr,dpr); ctx.font=font; ctx.fillStyle=color; ctx.textBaseline='alphabetic'; ctx.fillText(text,1,pad+cap);
    if (opts && opts.strike){ var midY=pad+Math.round(cap*0.62); ctx.strokeStyle=color; ctx.lineWidth=Math.max(1, Math.round(px*0.07)); ctx.beginPath(); ctx.moveTo(1,midY); ctx.lineTo(1+textW,midY); ctx.stroke(); }
    return c; }

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(ch){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[ch]; }); }

  // strip a leading "VIOFO " brand prefix (case-insensitive) to shorten product names.
  // also match a non-breaking space (CMS-pasted titles) around the brand word.
  function shortName(s){ return String(s==null?'':s).replace(/^[\s ]*viofo[\s ]+/i, '').trim(); }
  // microSD <select> option label from a capacityValue ("128" → "128GB"). Falls back
  // to the full card title when no numeric capacity was derived.
  function capLabel(o){ var v = o && o.capacityValue; return (v != null && v !== '') ? (String(v) + 'GB') : ((o && o.label) || ''); }
  function campaignConfig(){
    if (window.__campaignPageConfig) return window.__campaignPageConfig;
    var cfg = {};
    try {
      var el = document.getElementById('campaign-fp-config');
      if (el && el.textContent) cfg = JSON.parse(el.textContent) || {};
    } catch(e){ cfg = {}; }
    window.__campaignPageConfig = cfg;
    return cfg;
  }
  function campaignId(){ var v = campaignConfig().campaign; return v == null ? '' : String(v).trim(); }
  function isBundleTab(t){ return !!(t && (t.type === '2chb' || t.type === '3chb')); }
  function withCampaignProperties(item, tab, role){
    var cid = campaignId();
    if (!cid) return item;
    var p = { _campaign: cid, _bundle_role: role };
    // NO _channel (removed 2026-07-10, Bill ruling): tab.channel is the row's UI SLOT key
    // (it picks the media_2ch_*/media_3ch_* setting group), NOT the camera's channel count —
    // rows may put two different MODELS in the two slots (the A119 row holds A119M Pro +
    // A119 Mini 2, both 1CH; the Telephoto row's "2ch" slot holds the 3CH A329T), so
    // emitting it wrote wrong data into order line properties. Model identity already
    // rides on the variant id + _bundle_key; channel count is derivable from the model.
    if (isBundleTab(tab) && tab.key) p._bundle_key = String(tab.key);
    item.properties = p;
    return item;
  }
  function campaignAnalyticsItem(row, tab, rec){
    var vid = rec && rec.id != null ? rec.id : '';
    // item_id = PRODUCT id (P2 2026-07-10): the site-wide GA4 join key, aligned with the
    // site_* dispatcher; the variant id rides on the standard item_variant field. pid
    // missing (defensive — islands emit it for every record) → fall back to variant id.
    var pid = rec && rec.pid ? rec.pid : null;
    var out = {
      item_id: String(pid != null ? pid : vid),
      item_variant: String(vid),
      item_name: shortName((rec && rec.name) || (tab && (tab.productTitle || tab.label)) || ''),
      quantity: (rec && rec.quantity) || 1,
      bundle_role: (rec && rec.role) || 'base'
    };
    if (isBundleTab(tab) && tab && tab.key) out.bundle_key = String(tab.key);
    // NO channel item param (removed 2026-07-10, Bill ruling) — slot key ≠ channel count;
    // see the withCampaignProperties note above.
    return out;
  }
  function campaignListKey(row, tab){
    var data = (row && row.data) || {};
    return data.anchorId || (row && row.getAttribute && row.getAttribute('data-anchor-id')) || data.rowId || (row && row.id) || (tab && tab.type) || 'campaign';
  }

  // Render merchant text into `el` HONORING line breaks the merchant typed: a literal
  // <br> (any form: <br>, <br/>, <br />) OR a real newline becomes a <br> element;
  // every other character goes in as a plain TEXT NODE. Because we never touch
  // innerHTML, the ONLY node this can ever create is <br> — a merchant can't inject
  // <script>/<img onerror>/etc. Mirrors the SSR snippet 'campaign-rich-text' so the
  // first paint (Liquid) and this JS re-render produce identical breaks.
  function setRichText(el, str){
    if (!el) return;
    el.textContent = '';
    var parts = String(str == null ? '' : str).split(/<br\s*\/?>|\r\n|\r|\n/i);
    for (var i = 0; i < parts.length; i++){
      if (i) el.appendChild(document.createElement('br'));
      if (parts[i]) el.appendChild(document.createTextNode(parts[i]));
    }
  }

  customElements.define('campaign-product-row', class extends HTMLElement {
    connectedCallback(){
      if (this._init) return;
      // The element is defined from the head (campaign.js loads before this element's
      // markup), so it can upgrade & fire connectedCallback BEFORE its child subtree
      // (the .cpr-data island + buy panel) is parsed. Defer init until the data island
      // and the last hook (.btn-add) exist, otherwise we'd parse empty data once and latch.
      var dataEl = this.querySelector('.cpr-data');
      if (!dataEl || !dataEl.textContent.trim() || !this.querySelector('.btn-add')) {
        var selfDefer = this;
        // isConnected: if the element was removed while waiting (theme editor reload),
        // a late re-init would bind listeners/timers on a zombie node after its
        // disconnectedCallback already ran.
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ if (selfDefer.isConnected) selfDefer.connectedCallback(); }, { once: true });
        else setTimeout(function(){ if (selfDefer.isConnected) selfDefer.connectedCallback(); }, 0);
        return;
      }
      this._init = true;
      var data = {};
      try { data = JSON.parse(dataEl.textContent); } catch(e) { data = {}; }
      this.data = data;
      this.media = data.media || { '2ch':[], '3ch':[] };
      // MEDIA INHERITANCE (Bill 2026-07-03, precedence fixed same day): own channel →
      // own OTHER channel (same product) → first-row donor ONLY when the row has zero
      // media in BOTH channels (blank-pane protection for a freshly added row; island
      // read raw from DOM order, no init needed). The first row itself never inherits
      // (earlier bug: deleting row 1's 3CH made it borrow row 2's).
      var selfMedia = this.media;
      // 1) SAME-ROW fallback FIRST (Bill 2026-07-03 round 2): an empty channel reuses
      //    the row's OWN other channel, so the pane always shows THIS product. The old
      //    order tried the first-row donor before this, which put a DIFFERENT product's
      //    video on the row (bug report: A229 Pro 3CH played the A329S family clip).
      var own2 = (selfMedia['2ch'] || []).length > 0;
      var own3 = (selfMedia['3ch'] || []).length > 0;
      if (!own2 && own3) selfMedia['2ch'] = selfMedia['3ch'];
      if (!own3 && own2) selfMedia['3ch'] = selfMedia['2ch'];
      // 2) FIRST-ROW donor ONLY when the row has no media of its own AT ALL (both
      //    channels empty — e.g. a freshly added, not-yet-configured row): borrow the
      //    first row's lists so the pane isn't a blank dark box. The first row itself
      //    never inherits (its island IS the donor).
      if (!own2 && !own3){
        var firstIsland = document.querySelector('campaign-product-row .cpr-data');
        if (firstIsland && firstIsland !== dataEl){
          try {
            var donor = JSON.parse(firstIsland.textContent);
            ['2ch', '3ch'].forEach(function(ch){
              if ((selfMedia[ch] || []).length) return;
              if (donor.media && (donor.media[ch] || []).length) selfMedia[ch] = donor.media[ch];
            });
            // donor filled only one channel → mirror it to the other
            ['2ch', '3ch'].forEach(function(ch){
              var other = ch === '2ch' ? '3ch' : '2ch';
              if (!(selfMedia[ch] || []).length && (selfMedia[other] || []).length) selfMedia[ch] = selfMedia[other];
            });
          } catch(e){}
        }
      }
      var tabs = data.tabs || [];
      this.tabs = tabs;
      this.cur = 0;
      this._seq = 0;
      this._timers = [];      // pending one-shot timers (relocks/prewarm) — cleared on disconnect
      this._capId = null;     // selected capacity variant id
      this._mediaList = [];   // current channel's media entries (carousel)
      this._mediaIdx = 0;     // active carousel index
      this._mediaTimer = null;// per-slide auto-advance timer
      this._slideEls = [];    // rendered .mslide nodes (one per media entry)
      this._capEls = [];      // rendered .cap-block nodes (one per media entry)
      // focus-gated playback state (center-band IO below). Start SUSPENDED when IO is
      // available (2026-07-03 perf audit): rows init on page load regardless of viewport,
      // and a video that play()s even once starts its network fetch — with 6 rows that was
      // ~40MB of mp4 on first paint. The IO callback fires immediately after observe() and
      // wakes only the centered row. No-IO browsers keep the old always-playing behavior.
      this._playing = (typeof window.IntersectionObserver === 'function') ? false : true;
      this._focusIO = null;

      // cache DOM hooks
      this.$media   = this.querySelector('.media');
      this.$mstack  = this.querySelector('.media .mstack');
      this.$mbars   = this.querySelector('.media .mbars');
      this.$mprev   = this.querySelector('.media .mprev');
      this.$mnext   = this.querySelector('.media .mnext');
      // $cap = persistent authoritative caption MIRROR (off-screen, first child of
      // .mbars). It always holds the ACTIVE slide's caption text so the test hook
      // querySelector('.media .cap') returns the current caption regardless of which
      // visible .cap-block is active. We never remove/re-create this node.
      this.$cap     = this.querySelector('.media .cap');
      this.$tabbar  = this.querySelector('.tabbar');
      this.$panel   = this.querySelector('.panel');
      this.$eyebrow = this.querySelector('.eyebrow');
      this.$title   = this.querySelector('.ptitle');
      this.$desc    = this.querySelector('.pdesc');
      this.$pimg    = this.querySelector('.pimg');
      this.$tags    = this.querySelector('.tags');
      this.$incl    = this.querySelector('.incl');
      this.$capWrap = this.querySelector('.capacity');
      this.$capSel  = this.querySelector('[data-capsel]');
      this.$price   = this.querySelector('.cpr-price');
      this.$now     = this.querySelector('.now');
      this.$was     = this.querySelector('.was');
      this.$save    = this.querySelector('.save');
      this.$learn   = this.querySelector('.btn-learn');
      this.$add     = this.querySelector('.btn-add');

      var self = this;

      // NOTE: no hover-pause — Bill (2026-07-02) wants videos to keep playing with the
      // pointer over the media (the old mouseenter/mouseleave pause was removed).

      // manual prev/next arrows: jump a slide, then restart auto-advance from the
      // new slide (reuses showMedia + the same per-slide timer as auto-advance).
      if (this.$mprev) this.$mprev.addEventListener('click', function(){ self.manualNav(-1); });
      if (this.$mnext) this.$mnext.addEventListener('click', function(){ self.manualNav(1); });

      // tab bar bindings (static buttons already rendered by liquid; bind by data-tab)
      if (this.$tabbar){
        this.$tabbar.addEventListener('click', function(ev){
          var btn = ev.target.closest && ev.target.closest('[data-tab]');
          if (!btn || !self.$tabbar.contains(btn)) return;
          var type = btn.getAttribute('data-tab');
          for (var i=0;i<self.tabs.length;i++){
            if (self.tabs[i].type === type){
              if (i !== self.cur){
                self.switchTab(i);
                self.dispatchCampaignEvent('campaign:tabview', self.currentBaseAnalyticsItems());
              }
              break;
            }
          }
        });
      }

      // capacity select change
      if (this.$capSel){
        this.$capSel.addEventListener('change', function(){
          self.onCapacityChange();
        });
      }

      // CTA
      if (this.$learn){
        this.$learn.addEventListener('click', function(){
          self.dispatchCampaignEvent('campaign:learnmore', self.currentBaseAnalyticsItems());
        });
      }
      if (this.$add){
        this.$add.addEventListener('click', function(){
          if (!window.campaignAddItems) return;
          var btn = this;
          if (!window.campaignBusy(btn, true)) return;
          var analyticsItems = self.currentAnalyticsItems();
          // snapshot BEFORE the async call (P2 2026-07-10): the user may switch tabs while
          // the request is in flight — the value must price what was actually submitted.
          var submitted = self.currentItems();
          window.campaignAddItems(submitted).then(function(r){
            if (!(r && r.ok)) return;
            var cents = (window.campaignAtcValue && r.currency) ? window.campaignAtcValue(submitted, r.cartItems) : null;
            self.dispatchCampaignEvent('campaign:atc', analyticsItems,
              cents != null ? { value: Math.round(cents) / 100, currency: r.currency } : null);
          }).catch(function(){}).then(function(){ window.campaignBusy(btn, false); });
        });
      }

      if (this.tabs.length) this.switchTab(0);
      this.bindCampaignImpression();

      // ── focus-gated playback (Bill 2026-07-03) ──
      // Only the row over the viewport's CENTER BAND animates; every other row's
      // media is fully static (no slide rotation, video paused, progress emptied),
      // so the focused row never has neighbours moving above/below it. The 10%-tall
      // band keeps "focused" unambiguous — at most one row straddles it at rest.
      // Suspended rows stay static even through tab/arrow clicks (setMedia/manualNav
      // re-apply the suspension); entering focus restarts the current slide fresh.
      if (typeof window.IntersectionObserver === 'function'){
        this._focusIO = new IntersectionObserver(function(entries){
          // batched entries arrive oldest→newest; the last one is the current state
          self._setPlayback(entries[entries.length - 1].isIntersecting);
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        this._focusIO.observe(this);
      }

      // ── equal card height across all tabs ──
      // Measure each tab's natural panel height once the first render settles (wrapping
      // depends on width/fonts), lock the panel to the max so switching tabs never
      // changes the card height. Re-measure on resize (debounced). See lockEqualHeight().
      this._measuring = false;
      this._onResize = function(){
        if (self._resizeT) clearTimeout(self._resizeT);
        self._resizeT = setTimeout(function(){ self.lockEqualHeight(); }, 150);
      };
      window.addEventListener('resize', this._onResize);
      // rAF so the first tab's layout is committed; also re-run on window load (fonts/images).
      requestAnimationFrame(function(){ self.lockEqualHeight(); });
      window.addEventListener('load', function(){ self.lockEqualHeight(); }, { once: true });
      // Late-reflow correction: the web font (HarmonyOS) swapping in AFTER the first lock
      // re-flows text — bundle tabs have more text rows, so they grow a few px and end up
      // taller than the latched channel height. Re-lock once fonts are ready, with two short
      // fallbacks for any other late settle. lockEqualHeight has a re-entry guard and restores
      // the live capacity selection, so these extra runs are safe.
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(function(){ self.lockEqualHeight(); });
      this._timers.push(setTimeout(function(){ self.lockEqualHeight(); }, 400));
      this._timers.push(setTimeout(function(){ self.lockEqualHeight(); }, 1200));

      // Warm the price cache for the other tabs once the active tab's own probe has had time
      // to land, so switching tabs renders the price instantly instead of flashing "at checkout".
      this._timers.push(setTimeout(function(){ self._prewarmPrices(); }, 1400));
    }

    disconnectedCallback(){
      this._stopAuto();
      this._stopProg();
      if (this._focusIO){ try { this._focusIO.disconnect(); } catch(e){} this._focusIO = null; }
      if (this._campaignViewIO){ try { this._campaignViewIO.disconnect(); } catch(e){} this._campaignViewIO = null; }
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._resizeT) clearTimeout(this._resizeT);
      // The theme editor tears down + re-renders the section on every setting change:
      // pending relock/prewarm/debounce timers must die with the element, or detached
      // rows keep firing lockEqualHeight()/cartCreate probes (wasted throttle budget).
      if (this._debounce) clearTimeout(this._debounce);
      (this._timers || []).forEach(clearTimeout);
      this._timers = [];
    }

    // Lock every tab's card to the tallest tab's panel height so switching tabs never
    // changes the overall card height. Desktop only (the layout stacks ≤900px, where a
    // fixed desktop height is wrong — there we clear the lock). Measuring renders each
    // tab off the active one and reads its natural .panel height; recalc() is suppressed
    // during the loop (this._measuring) to avoid firing extra price probes, then the
    // originally-active tab is restored and its normal recalc() runs once.
    lockEqualHeight(){
      // isConnected: the rAF / window-load / fonts.ready callbacks can't be cancelled
      // on disconnect — make them no-ops on a detached element instead.
      if (!this.isConnected || !this.$panel || !this.tabs || this.tabs.length < 2) return;
      if (this._measuring) return;   // re-entry guard: a fonts/resize re-lock must not re-enter mid-measure
      // Responsive: at ≤900px the .pbody stacks (column) and the media has its own
      // aspect-ratio height — a desktop-measured lock would be wrong. Clear it.
      var stacked = (typeof window.matchMedia === 'function')
        ? window.matchMedia('(max-width: 900px)').matches
        : (window.innerWidth <= 900);
      if (stacked){ this.$panel.style.minHeight = ''; return; }

      var prev = this.cur;
      var savedCap = this._capId;   // preserve the live capacity choice across the measure cycle
      var maxH = 0;
      this._measuring = true;
      // clear any previous lock so we measure NATURAL content heights
      this.$panel.style.minHeight = '';
      try {
        for (var i=0;i<this.tabs.length;i++){
          this.switchTab(i);                 // renders tab i into the panel (recalc no-ops)
          var h = this.$panel.scrollHeight;  // natural content height (padding included)
          if (h > maxH) maxH = h;
        }
      } finally {
        // Always clear the flag + restore the active tab, even if a switchTab() throws,
        // so a render error can't permanently latch _measuring and freeze recalc() forever.
        this._measuring = false;
        this.switchTab(prev);
        this._restoreCapacity(savedCap);   // loop's renderCapacity reset the <select>; put the user's choice back
      }
      if (maxH > 0) this.$panel.style.minHeight = maxH + 'px';
    }

    // Re-apply a previously-selected capacity variant id after the measure loop reset the
    // <select> to its default — so a re-lock (fonts/resize) never clobbers the user's choice
    // or data-selected-capacity. No-op on channel tabs / unset selection.
    _restoreCapacity(id){
      if (id == null || !this.$capSel) return;
      var opts = this.$capSel.options, want = String(id);
      for (var i=0;i<opts.length;i++){
        if (opts[i].getAttribute('data-variant-id') === want){
          if (this.$capSel.selectedIndex !== i){
            this.$capSel.selectedIndex = i;
            this._capId = id;
            this.setAttribute('data-selected-capacity', id);
            this.renderIncluded();   // refresh microSD row (thumbnail/label) for the restored card
            this.recalc();           // re-price for the restored card, independent of any in-flight debounce
          }
          return;
        }
      }
    }

    // ── currentItems() & dedupe (transcribed verbatim shape; campaign properties are added at the edge) ──
    currentItemRecords(){
      var tabs=this.tabs, cur=this.cur, self=this;
      function pushUnique(out, seen, line, role){
        var id = line && line.id;
        var k=String(id==null?'':id).trim();
        if(!k||k==='0') return;
        if(seen.has(k)) return;
        seen.add(k);
        out.push({ id:id, pid:(line && line.pid) || null, quantity:(line && line.quantity) || 1, name:(line && (line.name || line.label)) || '', role:role });
      }
      function selectedCapacityLine(){ return self.selectedCapacityOption(); }
      var t=tabs[cur], out=[], seen=new Set();
      if (!t) return out;
      pushUnique(out,seen,t.baseLine,'base');
      if(t.capacityOptions.length) pushUnique(out,seen,selectedCapacityLine(),'card');
      t.accessoryLines.forEach(function(a){ pushUnique(out,seen,a,'accessory'); });
      t.giftLines.forEach(function(g){ pushUnique(out,seen,g,'gift'); });
      return out;
    }

    currentItems(){
      var tab = this.tabs[this.cur] || {};
      return this.currentItemRecords().map(function(rec){
        return withCampaignProperties({ id: rec.id, quantity: rec.quantity || 1 }, tab, rec.role);
      });
    }

    currentAnalyticsItems(){
      var tab = this.tabs[this.cur] || {}, self = this;
      return this.currentItemRecords().map(function(rec){ return campaignAnalyticsItem(self, tab, rec); });
    }

    currentBaseAnalyticsItems(){
      var tab = this.tabs[this.cur] || {};
      var base = tab.baseLine || {};
      return [campaignAnalyticsItem(this, tab, { id: base.id, pid: base.pid || null, quantity: base.quantity || 1, name: base.name || tab.productTitle || tab.label, role: 'base' })];
    }

    selectedCapacityOption(){
      var id = this.selectedCapacityId();
      if (id == null || !this.tabs || !this.tabs[this.cur]) return null;
      var opts = this.tabs[this.cur].capacityOptions || [];
      var want = String(id);
      for (var i=0;i<opts.length;i++){
        if (String(opts[i].id) === want) return opts[i];
      }
      return { id: id, quantity: 1 };
    }

    selectedCapacityId(){
      if (!this.$capSel) return null;
      var opt = this.$capSel.options[this.$capSel.selectedIndex];
      return opt ? opt.getAttribute('data-variant-id') : null;
    }

    dispatchCampaignEvent(type, items, extra){
      var tab = this.tabs[this.cur] || {};
      var detail = {
        rowId: (this.data && this.data.rowId) || this.id || '',
        anchorId: (this.data && this.data.anchorId) || this.getAttribute('data-anchor-id') || '',
        listKey: campaignListKey(this, tab),
        tabType: tab.type || '',
        tabLabel: tab.label || '',
        bundle_key: isBundleTab(tab) ? (tab.key || '') : '',
        url: tab.url || '',
        items: items || []
      };
      // extra: optional detail fields — currently only campaign:atc's value/currency
      // (P2 2026-07-10). The analytics consumer hard-gates money to the atc type anyway.
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) detail[k] = extra[k];
      this.dispatchEvent(new CustomEvent(type, { bubbles: true, detail: detail }));
    }

    bindCampaignImpression(){
      var self = this;
      if (!this.tabs || !this.tabs.length) return;
      if (this._campaignViewed) return;
      if (typeof window.IntersectionObserver !== 'function'){
        this._campaignViewed = true;
        this.dispatchCampaignEvent('campaign:view', this.currentBaseAnalyticsItems());
        return;
      }
      this._campaignViewIO = new IntersectionObserver(function(entries){
        for (var i=0;i<entries.length;i++){
          var entry = entries[i];
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5){
            self._campaignViewed = true;
            self.dispatchCampaignEvent('campaign:view', self.currentBaseAnalyticsItems());
            try { self._campaignViewIO.unobserve(self); self._campaignViewIO.disconnect(); } catch(e){}
            self._campaignViewIO = null;
            break;
          }
        }
      }, { threshold: [0, 0.5] });
      this._campaignViewIO.observe(this);
    }

    switchTab(i){
      if (i<0 || i>=this.tabs.length) return;
      this.cur = i;
      var t = this.tabs[i];

      // active state on tab buttons (+aria-pressed so SRs hear which tab is on)
      if (this.$tabbar){
        var btns = this.$tabbar.querySelectorAll('[data-tab]');
        for (var b=0;b<btns.length;b++){
          var onBtn = (btns[b].getAttribute('data-tab') === t.type);
          btns[b].classList.toggle('active', onBtn);
          btns[b].setAttribute('aria-pressed', onBtn ? 'true' : 'false');
        }
      }

      // eyebrow / title / description / product image
      // title prefers an optional short headline; falls back to the PRODUCT name
      // (productTitle) — which keeps the row-tabs 2CH/3CH assertion valid — then label.
      // setRichText (not textContent) so a merchant-typed <br> renders as a real line
      // break instead of literal "<br>" characters (Bill 2026-07-03).
      if (this.$eyebrow) setRichText(this.$eyebrow, t.eyebrow || '');
      if (this.$title)   setRichText(this.$title, t.headline || t.productTitle || t.label || '');
      if (this.$desc)    setRichText(this.$desc, t.desc || '');
      if (this.$pimg){
        if (t.img){ this.$pimg.src = t.img; this.$pimg.hidden = false; }
        else { this.$pimg.removeAttribute('src'); this.$pimg.hidden = true; }
      }
      if (this.$learn){
        if (t.url) this.$learn.setAttribute('href', t.url);
        else this.$learn.setAttribute('href', '#');
      }

      var isBundle = (t.type === '2chb' || t.type === '3chb');

      // tags vs included-list
      if (this.$tags){
        this.$tags.innerHTML = '';
        var tagStr = (!isBundle ? (t.tags || '') : '');
        if (tagStr) tagStr.split(',').forEach(function(s){ var v = s.trim(); if(!v) return; var sp = document.createElement('span'); sp.className = 'tag'; sp.textContent = v; this.$tags.appendChild(sp); }, this);
      }
      this.renderIncluded();

      // capacity selector (bundle only)
      this.renderCapacity();

      // media bound to CHANNEL (2chb→2ch media, 3chb→3ch media)
      this.setMedia(t.channel);

      // price: the active items just changed. If this tab's price is already cached (fresh),
      // paint it synchronously — no "at checkout" flash; otherwise drop to neutral so a stale
      // number can't linger during the probe. recalc() then confirms/refreshes either way.
      // Skip during the equal-height measure loop (recalc no-ops there; same items restored
      // after — must not flash).
      if (!this._measuring) this._repriceOnChange();
      this.recalc();
    }

    // dwell time (ms) for a slide: explicit video duration, else default image dwell.
    _slideDuration(m){
      var d = m && m.duration ? Number(m.duration) : 0;
      if (!d || d < 600 || !isFinite(d)) d = 4000;   // 0/absent/junk → image default
      return d;
    }

    setMedia(channel){
      // Rebuild the crossfade carousel for the channel's media list. Each entry
      // becomes one .mslide (video OR image) + one .cap-block (caption + filling
      // track). The authoritative .cap mirror is kept and its text set to the
      // active slide's caption (test hook `.media .cap`.textContent), so captions
      // differ between 2ch/3ch and across tab switches.
      this._stopAuto();
      this._stopProg();
      var self = this;
      var list = (this.media && this.media[channel]) || [];
      this._mediaList = list;
      this._mediaIdx = 0;
      this._slideEls = [];
      this._capEls = [];

      if (this.$mstack){
        if (!list.length){
          this.$mstack.innerHTML = '<div class="mslide is-active"></div>';
        } else {
          var sh = '';
          for (var i=0;i<list.length;i++){
            var m = list[i] || {};
            var inner = '';
            if (m.video){
              // loop ONLY when it's the sole slide (nothing to advance to). With 2+
              // slides the 'ended' event drives the advance — loop would swallow it.
              // NO autoplay attr + preload="none" (2026-07-03 perf audit): autoplay makes
              // the browser buffer EVERY row's videos at page load (~40MB before any
              // scroll). Playback is 100% JS-driven (showMedia gated by the focus IO), so
              // the attr was redundant; preload="none" defers the fetch to that play()
              // call. The poster covers the sub-second startup when a row gains focus.
              inner = '<video muted ' + (list.length < 2 ? 'loop ' : '') + 'playsinline disablepictureinpicture preload="none"'
                    + (m.poster ? ' poster="'+esc(m.poster)+'"' : '')
                    + '><source src="'+esc(m.video)+'" type="video/mp4"></video>';
            } else if (m.img){
              // srcset lets mobile (~100vw pane) pull the 800w file instead of 1600w;
              // desktop 2x still gets 1600. imgSm comes from the liquid JSON island.
              var ss = (m.imgSm && m.imgSm !== m.img)
                ? ' srcset="'+esc(m.imgSm)+' 800w, '+esc(m.img)+' 1600w" sizes="(max-width: 900px) 100vw, 653px"'
                : '';
              inner = '<img class="pmedia" src="'+esc(m.img)+'"'+ss+' alt="'+esc(m.cap||'')+'" loading="lazy">';
            }
            sh += '<div class="mslide'+(i===0?' is-active':'')+'">'+inner+'</div>';
          }
          this.$mstack.innerHTML = sh;
        }
        this._slideEls = Array.prototype.slice.call(this.$mstack.querySelectorAll('.mslide'));
        // a finished ACTIVE video advances the carousel right on its real end
        // (the dwell timer stays armed as a safety net — see _startAuto)
        var vids = this.$mstack.querySelectorAll('video');
        for (var vi = 0; vi < vids.length; vi++){
          vids[vi].addEventListener('ended', function(ev){
            var slide = ev.target.closest && ev.target.closest('.mslide');
            if (!slide || !slide.classList.contains('is-active')) return;
            if ((self._mediaList || []).length < 2) return;
            self.showMedia(self._mediaIdx + 1);
            self._startAuto();
          });
        }
      }

      // rebuild visible .cap-block nodes (the authoritative .cap mirror is preserved)
      if (this.$mbars){
        // drop old cap-blocks, keep the .cap mirror
        var olds = this.$mbars.querySelectorAll('.cap-block');
        for (var d=0; d<olds.length; d++){ olds[d].parentNode.removeChild(olds[d]); }
        var bh = '';
        var n = list.length || 1;
        for (var j=0;j<n;j++){
          var c = (list[j] && list[j].cap) || '';
          bh += '<span class="cap-block'+(j===0?' is-active':'')+'">'
              + '<span class="cap-t">'+esc(c)+'</span>'
              + '<span class="cap-track"><span class="cap-fill"></span></span></span>';
        }
        this.$mbars.insertAdjacentHTML('beforeend', bh);
        this._capEls = Array.prototype.slice.call(this.$mbars.querySelectorAll('.cap-block'));
      }

      // prev/next arrows only make sense with 2+ slides
      var multi = (list.length >= 2);
      if (this.$mprev) this.$mprev.hidden = !multi;
      if (this.$mnext) this.$mnext.hidden = !multi;

      this.showMedia(0);
      if (list.length >= 2) this._startAuto();
      if (this._playing === false) this._suspendMedia();   // off-focus rows stay static
    }

    // manual slide nav (arrow click): pause, advance, restart auto from the new slide.
    manualNav(dir){
      var list = this._mediaList || [];
      if (list.length < 2) return;
      this._stopAuto();
      this.showMedia(this._mediaIdx + (dir || 1));
      this._startAuto();
      if (this._playing === false) this._suspendMedia();   // flip slides, stay static off-focus
    }

    showMedia(idx){
      var list = this._mediaList || [];
      var len = list.length;
      if (!len){
        if (this.$cap) this.$cap.textContent = '';
        return;
      }
      idx = ((idx % len) + len) % len;
      this._mediaIdx = idx;

      // crossfade slides
      for (var i=0;i<this._slideEls.length;i++){
        var on = (i === idx);
        this._slideEls[i].classList.toggle('is-active', on);
        // (re)play the active video from the start; pause inactive ones.
        // play() is what starts a preload="none" video's network fetch, so it is GATED:
        // suspended rows (off the focus band) and the equal-height measure loop must not
        // fetch. currentTime=0 sits in its own try — on a no-data video the setter can
        // throw InvalidState, which must not swallow the play() call.
        var v = this._slideEls[i].querySelector('video');
        if (v){
          if (on && this._playing !== false && !this._measuring){
            try { v.currentTime = 0; } catch(e){}
            try { var pl = v.play(); if (pl && pl.catch) pl.catch(function(){}); } catch(e){}
          }
          else if (!on){ try { v.pause(); } catch(e){} }
        }
      }

      // caption bars: active caption white, its track fills over the slide duration.
      this._stopProg();
      var dur = this._slideDuration(list[idx]);
      var activeVideo = this._slideEls[idx] && this._slideEls[idx].querySelector('video');
      for (var k=0;k<this._capEls.length;k++){
        var capEl = this._capEls[k];
        var active = (k === idx);
        capEl.classList.toggle('is-active', active);
        var fill = capEl.querySelector('.cap-fill');
        if (fill){
          if (active && activeVideo){
            // VIDEO slide: the fill mirrors REAL playback (currentTime/duration, rAF).
            // A metadata-length CSS transition drifts (autoplay delay, buffering) and
            // ignores hover-pause; currentTime freezes with the video, so the bar
            // freezes/resumes in perfect sync for free.
            fill.classList.remove('run');
            fill.style.transition = 'none';
            fill.style.transform = 'scaleX(0)';
            this._startProg(activeVideo, fill);
          } else if (active){
            // IMAGE slide: restart the fill animation — reset, force reflow, then run
            // to full over `dur` ms via a transform(scaleX) transition keyed to this slide.
            fill.classList.remove('run');
            fill.style.transition = 'none';
            fill.style.transform = 'scaleX(0)';
            void fill.offsetWidth;            // force reflow so the reset takes
            fill.style.transition = 'transform ' + dur + 'ms linear';
            fill.style.transform = '';        // let .run drive scaleX(1)
            fill.classList.add('run');
          } else {
            fill.classList.remove('run');
            fill.style.transition = 'none';
            fill.style.transform = '';
          }
        }
      }

      // authoritative .cap mirror reflects the ACTIVE slide's caption (test hook)
      if (this.$cap) this.$cap.textContent = (list[idx] && list[idx].cap) || '';
    }

    _startAuto(){
      // per-slide timer: schedule the next advance after THIS slide's dwell time.
      var self = this;
      this._stopAuto();
      var list = this._mediaList || [];
      if (list.length < 2) return;
      var m = list[this._mediaIdx] || {};
      // Video slides normally advance on their 'ended' event (real playback end); this
      // timer is only a SAFETY NET (+2s slack) so an erroring/stalled video can't wedge
      // the carousel. When 'ended' fires first it reschedules via _startAuto, so the
      // net never triggers in the normal path.
      var dur = this._slideDuration(m) + (m.video ? 2000 : 0);
      this._mediaTimer = setTimeout(function(){
        self.showMedia(self._mediaIdx + 1);
        self._startAuto();   // reschedule with the NEW slide's duration
      }, dur);
    }

    _stopAuto(){
      if (this._mediaTimer){ clearTimeout(this._mediaTimer); this._mediaTimer = null; }
    }

    // ── focus-gated playback helpers (center-band IO in connectedCallback) ──
    // Freeze the carousel in place: kill the dwell timer + progress rAF, pause the
    // active video (no reset), and empty the active caption bar so a half-visible
    // suspended row shows a clean static frame instead of a stuck-full progress bar.
    _suspendMedia(){
      this._stopAuto();
      this._stopProg();
      var act = this._slideEls && this._slideEls[this._mediaIdx];
      var v = act && act.querySelector('video');
      if (v){ try { v.pause(); } catch(e){} }
      var cap = this._capEls && this._capEls[this._mediaIdx];
      var fill = cap && cap.querySelector('.cap-fill');
      if (fill){ fill.classList.remove('run'); fill.style.transition = 'none'; fill.style.transform = 'scaleX(0)'; }
    }

    _setPlayback(on){
      on = !!on;
      if (on === this._playing) return;
      this._playing = on;
      if (on){
        // re-enter the current slide fresh: video restarts from 0, caption fill
        // restarts, dwell timer re-arms — exactly the showMedia contract.
        this.showMedia(this._mediaIdx);
        this._startAuto();
      } else {
        this._suspendMedia();
      }
    }

    // rAF loop: paint the active caption bar from the video's REAL playback position.
    // Started by showMedia() for video slides; stopped on the next showMedia()/setMedia()
    // or disconnect. Hover-pause freezes currentTime, so the bar freezes too.
    _startProg(v, fill){
      var self = this;
      this._stopProg();
      var step = function(){
        if (!self.isConnected){ self._progRaf = null; return; }
        var d = v.duration;
        if (d && isFinite(d) && d > 0) fill.style.transform = 'scaleX(' + Math.min(1, v.currentTime / d) + ')';
        self._progRaf = requestAnimationFrame(step);
      };
      this._progRaf = requestAnimationFrame(step);
    }

    _stopProg(){
      if (this._progRaf){ cancelAnimationFrame(this._progRaf); this._progRaf = null; }
    }

    renderCapacity(){
      var t = this.tabs[this.cur];
      var opts = t.capacityOptions || [];
      if (!this.$capSel || !this.$capWrap) return;
      // The .capacity wrapper is only a parking spot for the persistent <select>;
      // when there are options the select lives inside the .incl microSD row
      // (relocated by renderIncluded). Keep the empty wrapper hidden either way.
      this.$capWrap.hidden = true;
      if (!opts.length){
        this.$capSel.innerHTML = '';
        this._capId = null;
        this.removeAttribute('data-selected-capacity');
        return;
      }
      var html = '', selIdx = 0;
      for (var i=0;i<opts.length;i++){
        var o = opts[i];
        if (o.selected) selIdx = i;
        html += '<option value="'+esc(o.capacityValue)+'" data-variant-id="'+esc(o.id)+'">'+esc(capLabel(o))+'</option>';
      }
      this.$capSel.innerHTML = html;
      this.$capSel.selectedIndex = selIdx;
      this._capId = this.selectedCapacityId();
      if (this._capId != null) this.setAttribute('data-selected-capacity', this._capId);
      else this.removeAttribute('data-selected-capacity');
    }

    onCapacityChange(){
      this._capId = this.selectedCapacityId();
      if (this._capId != null) this.setAttribute('data-selected-capacity', this._capId);
      this.renderIncluded();
      // active items changed (capacity variant) → render cached price if fresh, else neutral,
      // before the probe repaints (avoids the "at checkout" flash when already priced).
      this._repriceOnChange();
      this.recalc();
    }

    renderIncluded(){
      var t = this.tabs[this.cur];
      if (!this.$incl) return;
      var isBundle = (t.type === '2chb' || t.type === '3chb');

      // Park the persistent capacity <select> back in .capacity BEFORE wiping .incl,
      // so its node (and the change listener bound once in connectedCallback) survives
      // the innerHTML replacement. We re-home it into the microSD row below for bundles.
      if (this.$capSel && this.$capWrap && this.$capSel.parentNode !== this.$capWrap){
        this.$capWrap.appendChild(this.$capSel);
      }

      if (!isBundle){ this.$incl.innerHTML = ''; return; }

      var hasCap = (t.capacityOptions || []).length > 0;
      // SVG icon chips (outline, currentColor) keyed to row kind
      var IC = {
        sd:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2h11l5 5v15a0 0 0 0 1 0 0H4a0 0 0 0 1 0 0z"/><path d="M10 6v3M13 6v3M16 7v2"/></svg>',
        acc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 7l-5 5 5 5"/><path d="M9 12h11"/></svg>',
        gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8M3 7h18v4H3V7Zm9 0v14M12 7S10.5 3 8.5 3 6 4 6 4.5 6.5 7 8 7h4Zm0 0s1.5-4 3.5-4S18 4 18 4.5 17.5 7 16 7h-4Z"/></svg>'
      };
      // Each row's thumbnail = the item's real product image when present
      // (object-fit:contain inside the .ic chip), else the SVG icon fallback.
      function chip(img, ic){
        var inner = img ? '<img src="'+esc(img)+'" alt="" loading="lazy">' : ic;
        return '<span class="ic" aria-hidden="true">'+inner+'</span>';
      }
      // qty renders as "x N" right AFTER the name/select (inside .nm, spaced by its gap).
      // Letter x, not the U+00D7 multiply sign — the math glyph sits high/small next to
      // digits and read as odd (Bill 2026-07-02).
      function row(img, ic, name, slot, qty){
        return '<li class="it">'+chip(img, ic)
             + '<span class="nm"><span class="nm-t">'+esc(name)+'</span>'+(slot||'')
             + '<span class="it-qty">x '+(qty || 1)+'</span></span></li>';
      }

      // Camera itself is left off this list (Bill: it's already the main product image/title,
      // listing it again read as redundant and padded the bundle tab's height well past a
      // plain channel tab's, forcing extra whitespace there via lockEqualHeight). Only what
      // the bundle ADDS on top of the camera shows here.
      var html = '<span class="incl-h">Bundle Accessories</span>';
      if (hasCap){
        // microSD thumbnail = the CURRENTLY-SELECTED capacity card's image (re-renders
        // on capacity change via onCapacityChange → renderIncluded). Match by selected
        // variant id; fall back to the option flagged selected:true.
        var selId = this.selectedCapacityId();
        var capOpts = t.capacityOptions || [];
        var selCap = null;
        for (var ci=0; ci<capOpts.length; ci++){
          if (selId != null && String(capOpts[ci].id) === String(selId)){ selCap = capOpts[ci]; break; }
        }
        if (!selCap){ for (var cj=0; cj<capOpts.length; cj++){ if (capOpts[cj].selected){ selCap = capOpts[cj]; break; } } }
        if (!selCap && capOpts.length) selCap = capOpts[0];
        html += row((selCap && selCap.img) || '', IC.sd, 'microSD card', '<span class="cap-slot"></span>'); // select goes here
      }
      // accessories: real product names from accessoryLines[].name (brand-stripped)
      (t.accessoryLines || []).forEach(function(a, idx){
        html += row((a && a.img) || '', IC.acc, shortName((a && a.name) || ('Accessory ' + (idx+1))), '', a && a.quantity);
      });
      // free gifts fold into this same list as the LAST rows (Bill 2026-07-02: the
      // separate FREE GIFT box padded the bundle tab's height — merging it here shrinks
      // the whole row via lockEqualHeight). One row per gift: thumbnail + name + a red
      // FREE tag pinned to the row's right edge (.it is flex; margin-left:auto in CSS).
      (t.giftLines || []).forEach(function(g, idx){
        html += '<li class="it">' + chip((g && g.img) || '', IC.gift)
              + '<span class="nm"><span class="nm-t">' + esc(shortName((g && g.name) || ('Gift ' + (idx + 1)))) + '</span>'
              + '<span class="it-qty">x ' + ((g && g.quantity) || 1) + '</span></span>'
              + '<span class="free-tag">FREE</span></li>';
      });
      this.$incl.innerHTML = html;

      // re-home the persistent select into the microSD row's slot
      if (hasCap && this.$capSel){
        var slot = this.$incl.querySelector('.cap-slot');
        if (slot) slot.appendChild(this.$capSel);
      }
    }

    recalc(){
      // suppress price probes while measuring equal-height (lockEqualHeight switches
      // through every tab) — avoids a burst of extra cartCreate probes.
      if (this._measuring) return;
      var self = this;
      // Bump the sequence SYNCHRONOUSLY at entry (not inside the debounce) so any probe
      // already in-flight from a prior recalc is invalidated the instant a new recalc is
      // requested. Otherwise, a probe whose 150ms debounce already FIRED would still match
      // _seq during the new debounce window and paint the previous tab's price onto the new
      // tab. Capture it here and reuse it inside the debounced probe.
      var seq = ++self._seq;
      if (this._debounce) clearTimeout(this._debounce);
      this._debounce = setTimeout(function(){
        if (!self.isConnected) return;   // disconnected while debouncing → no probe
        var tab = self.tabs[self.cur];
        var items = self.currentItems();
        if (!window.CampaignPricing || !window.CampaignPricing.priceTab){ self.renderPrice({status:'neutral'}); return; }
        window.CampaignPricing.priceTab(items, { level: tab.level || 'line' }).then(function(r){
          // isConnected: the row can disconnect while the probe is IN FLIGHT (editor section
          // reload) — seq alone doesn't catch that (disconnect doesn't bump it). Checked here
          // rather than bumping _seq in disconnectedCallback so a same-task DOM move
          // (disconnect→reconnect) still paints the valid result instead of latching neutral.
          if (!self.isConnected || seq !== self._seq) return;   // detached/stale → drop
          self.renderPrice(r);
        }.bind(self));
      }, 150);
    }

    // Show the neutral/loading price state immediately (no number lingers while a probe is
    // in flight). Same path renderPrice() uses for non-ok: .now → "at checkout", clear
    // .was/.save (no leftover canvas), data-status="neutral". Called synchronously from the
    // real items-change points (switchTab/onCapacityChange) so the on-screen price can never
    // be a number that doesn't match the pending items. NOT called on the capacity-restore
    // recalc after equal-height measuring (same items → must not flash).
    _neutralizePrice(){ this.renderPrice({ status: 'neutral' }); }

    // Repaint the price on an items change WITHOUT the "at checkout" flash when possible:
    // synchronously peek the pricer's paint-window cache (10min; network re-confirm stays
    // 60s) and, on a hit, render the last confirmed number immediately; only fall back to
    // the neutral placeholder on a genuine cache miss (first visit of a combination). The
    // subsequent recalc() confirms from the network (a cache hit resolves instantly to the
    // same value → no visible change). Prewarming (below) keeps the cache full so most
    // switches hit. Never shows a STALE number: the peek is keyed by the NEW items.
    _repriceOnChange(){
      var hit = null;
      try {
        if (window.CampaignPricing && window.CampaignPricing.peek){
          var tab = this.tabs[this.cur];
          hit = window.CampaignPricing.peek(this.currentItems(), { level: tab.level || 'line' });
        }
      } catch(e){}
      if (hit) this.renderPrice(hit);
      else this._neutralizePrice();
    }

    // Items for a tab at its DEFAULT capacity, WITHOUT switching to it — used to prewarm the
    // price cache for tabs the user hasn't opened yet. Must price exactly what a REAL switch
    // will: switchTab → renderCapacity() resets the <select> to the option flagged selected
    // (else the first) — capacity does NOT carry across tabs — so only that default's cache
    // key can ever be hit. (Not the live _capId: that's the CURRENT tab's selection; keying
    // other tabs off it warms entries no switch will read.)
    _itemsForTab(t){
      var out=[], seen=new Set();
      function pushUnique(id){ var k=String(id==null?'':id).trim(); if(!k||k==='0'||seen.has(k)) return; seen.add(k); out.push({id:id, quantity:1}); }
      pushUnique(t.baseLine && t.baseLine.id);
      if (t.capacityOptions && t.capacityOptions.length){
        var sel = null;
        for (var j=0;j<t.capacityOptions.length;j++){ if(t.capacityOptions[j].selected){ sel=t.capacityOptions[j]; break; } }
        if (!sel) sel = t.capacityOptions[0];
        if (sel) pushUnique(sel.id);
      }
      (t.accessoryLines||[]).forEach(function(a){ pushUnique(a.id); });
      (t.giftLines||[]).forEach(function(g){ pushUnique(g.id); });
      return out;
    }

    // Best-effort: warm the price cache for EVERY tab shortly after load so later switches
    // render instantly (no "at checkout" flash). Staggered so the tokenless cartCreate probes
    // don't burst (which the store throttles); each is a normal priceTab() call, so it dedupes
    // against the active tab's in-flight probe and only caches on success. If throttled it
    // silently fails and that tab simply falls back to the placeholder on first open (today's
    // behavior). Runs once.
    _prewarmPrices(){
      if (this._prewarmed || !window.CampaignPricing || !window.CampaignPricing.priceTab) return;
      this._prewarmed = true;
      var self = this;
      var tabs = this.tabs || [];
      tabs.forEach(function(t, i){
        // the active tab is already being priced by its own recalc — skip to avoid a dup
        if (i === self.cur) return;
        self._timers.push(setTimeout(function(){
          try { window.CampaignPricing.priceTab(self._itemsForTab(t), { level: t.level || 'line' }); } catch(e){}
        }, 350 * (i + 1)));
      });
    }

    renderPrice(r){
      var fmt = moneyFmt();
      var expose = (window.__campaignExposePrice === true);
      if (!this.$now || !this.$price) return;

      // always clear data-* first
      this.$now.removeAttribute('data-cents');
      this.$now.removeAttribute('data-money');
      this.$now.removeAttribute('data-currency');

      if (r && r.status === 'ok' && canvasOK()){
        var money = fmtMoney(r.netCents, fmt);
        this.$now.textContent = '';
        this.$now.appendChild(canvasText(money, 28, '#1A2A38', 800));
        var hasSaved = (r.savedCents && r.savedCents > 0);
        // was = net + saved (original price); save = saved amount. Because now = was − save,
        // a readable was/save would let a scraper reconstruct the canvas-protected .now price.
        // So render their NUMERIC money through canvasText too — no readable digits in the DOM.
        // (clear the element first so no leftover canvas/text; when no discount, fully empty
        // it so .was:empty / .save:empty keep it hidden.)
        if (this.$was){
          this.$was.textContent = '';
          if (hasSaved) this.$was.appendChild(canvasText(fmtMoney((r.netCents || 0) + r.savedCents, fmt), 15, '#9fb0bd', 400, { strike: true }));
        }
        if (this.$save){
          this.$save.textContent = '';
          if (hasSaved){
            // static word "Save " reveals nothing → plain text node; the AMOUNT is canvased.
            this.$save.appendChild(document.createTextNode('Save '));
            this.$save.appendChild(canvasText(fmtMoney(r.savedCents, fmt), 12, '#E60012', 600));
          }
        }
        this.$price.setAttribute('data-status', 'ok');
        if (expose){
          this.$now.setAttribute('data-cents', r.netCents);
          this.$now.setAttribute('data-money', money);
          this.$now.setAttribute('data-currency', r.currency || '');
        }
      } else {
        // neutral: EMPTY while the probe runs (Bill 2026-07-02: no placeholder text; the
        // .cpr-price min-height reserves the space so the row doesn't jump), no data-*
        this.$now.textContent = '';
        if (this.$was) this.$was.textContent = '';
        if (this.$save) this.$save.textContent = '';
        this.$price.setAttribute('data-status', 'neutral');
      }
    }
  });
})();

/* ── campaign-accessories custom element — model-tabbed carousel ─────────────
   "Complete your setup" style. Tab clicks filter cards by data-models
   (the active tab's data-model must be in a card's space-separated data-models).
   ‹ › arrows smooth-scroll the track by ~one card. Each card's Add button reuses
   the shared window.campaignAddItems helper. State is instance-scoped; one
   delegated click listener on the host keeps teardown trivial. */
(function(){
  if (typeof window === 'undefined' || !window.customElements) return;
  if (customElements.get('campaign-accessories')) return;   // double-define guard

  function accShortName(s){ return String(s==null?'':s).replace(/^[\s ]*viofo[\s ]+/i, '').trim(); }
  function accCampaignConfig(){
    if (window.__campaignPageConfig) return window.__campaignPageConfig;
    var cfg = {};
    try {
      var el = document.getElementById('campaign-fp-config');
      if (el && el.textContent) cfg = JSON.parse(el.textContent) || {};
    } catch(e){ cfg = {}; }
    window.__campaignPageConfig = cfg;
    return cfg;
  }
  function accCampaignId(){ var v = accCampaignConfig().campaign; return v == null ? '' : String(v).trim(); }
  function accWithCampaignProperties(item, role){
    var cid = accCampaignId();
    if (!cid) return item;
    item.properties = { _campaign: cid, _bundle_role: role };
    return item;
  }
  function accAnalyticsItem(rec){
    var vid = rec && rec.id != null ? rec.id : '';
    var pid = rec && rec.pid ? rec.pid : null;   // product id via data-product-id (P2 2026-07-10)
    return {
      item_id: String(pid != null ? pid : vid),
      item_variant: String(vid),
      item_name: accShortName((rec && rec.name) || ''),
      quantity: (rec && rec.quantity) || 1,
      bundle_role: (rec && rec.role) || 'carousel'
    };
  }

  customElements.define('campaign-accessories', class extends HTMLElement {
    connectedCallback(){
      if (this._init) return;
      var self = this;
      // The element may upgrade before its card subtree is parsed (campaign.js loads
      // from <head>). Defer until the track exists so binding doesn't latch on an
      // empty subtree.
      if (!this.querySelector('.cacc-track')){
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ self.connectedCallback(); }, { once: true });
        else setTimeout(function(){ self.connectedCallback(); }, 0);
        return;
      }
      this._init = true;

      this.$tabs  = Array.prototype.slice.call(this.querySelectorAll('.cacc-tab'));
      this.$track = this.querySelector('.cacc-track');
      this.$cards = Array.prototype.slice.call(this.querySelectorAll('.acard'));
      this.$cards.forEach(function(c, i){ c._accIdx = i; });   // collection order, for stable re-sorting
      this.$arrows = Array.prototype.slice.call(this.querySelectorAll('.cacc-arrow'));

      // single delegated click handler on the host (tabs, arrows, Add buttons)
      this._onClick = function(ev){
        var t = ev.target;
        var tab = t.closest && t.closest('.cacc-tab');
        if (tab && self.contains(tab)){ self.applyFilter(tab.getAttribute('data-model')); return; }
        var arrow = t.closest && t.closest('.cacc-arrow');
        if (arrow && self.contains(arrow)){ self.scrollByCard(arrow.getAttribute('data-dir') === 'prev' ? -1 : 1); return; }
        var add = t.closest && t.closest('.acc-add');
        if (add && self.contains(add)){
          var card = add.closest('.acard');
          if (!card) return;
          var id = parseInt(card.getAttribute('data-variant-id'), 10);
          if (!id || isNaN(id)) return;
          try {
            if (!window.campaignAddItems) return;
            var pid = card.getAttribute('data-product-id') || null;
            var item = accWithCampaignProperties({ id: id, quantity: 1 }, 'carousel');
            var name = card.getAttribute('data-item-name') || '';
            var analyticsItem = accAnalyticsItem({ id: id, pid: pid, quantity: 1, name: name, role: 'carousel' });
            // snapshot = the submit payload itself (properties included — the value matcher
            // reads id/quantity/properties only). P2 2026-07-10.
            var submitted = [item];
            if (!window.campaignBusy(add, true)) return;
            window.campaignAddItems(submitted).then(function(r){
              if (r && r.ok){
                var cents = (window.campaignAtcValue && r.currency) ? window.campaignAtcValue(submitted, r.cartItems) : null;
                var detail = {
                  rowId: self.getAttribute('data-section-id') || self.id || '',
                  anchorId: '',
                  listKey: self.id || self.getAttribute('data-section-id') || 'accessories',
                  tabType: 'accessories',
                  tabLabel: 'Accessories',
                  bundle_key: '',
                  items: [analyticsItem]
                };
                if (cents != null){ detail.value = Math.round(cents) / 100; detail.currency = r.currency; }
                self.dispatchEvent(new CustomEvent('campaign:atc', { bubbles: true, detail: detail }));
              }
            }).catch(function(){}).then(function(){ window.campaignBusy(add, false); });
          } catch(e){}
          return;
        }
        // accessory card image/title link → select_item (Bill 2026-07-10). The links are
        // real <a target="_blank"> (new tab), so THIS page survives the click and the
        // dataLayer push flushes normally. Reuses the campaign:learnmore →
        // campaign_select_item → GA4 select_item pipeline — zero GTM change. Same listKey
        // expression as the ATC dispatch above so both share one item_list_id.
        // .acc-add is a <button> outside .athumb/.aname → never reaches this branch.
        var lnk = t.closest && t.closest('.athumb, .aname');
        if (lnk && self.contains(lnk)){
          var lcard = lnk.closest('.acard');
          if (!lcard) return;
          var lid = parseInt(lcard.getAttribute('data-variant-id'), 10);
          if (!lid || isNaN(lid)) return;
          try {
            self.dispatchEvent(new CustomEvent('campaign:learnmore', {
              bubbles: true,
              detail: {
                rowId: self.getAttribute('data-section-id') || self.id || '',
                anchorId: '',
                listKey: self.id || self.getAttribute('data-section-id') || 'accessories',
                tabType: 'accessories',
                tabLabel: 'Accessories',
                bundle_key: '',
                items: [accAnalyticsItem({ id: lid, pid: lcard.getAttribute('data-product-id') || null, quantity: 1, name: lcard.getAttribute('data-item-name') || '', role: 'carousel' })]
              }
            }));
          } catch(e){}
          return;
        }
      };
      this.addEventListener('click', this._onClick);

      // keep arrow disabled-state fresh as the track scrolls
      if (this.$track){
        this._onScroll = function(){ self.updateArrows(); };
        this.$track.addEventListener('scroll', this._onScroll, { passive: true });
      }

      // apply the active (or first) tab's filter so only its cards show on init
      var active = this.$tabs.filter(function(b){ return b.classList.contains('is-active'); })[0] || this.$tabs[0];
      if (active) this.applyFilter(active.getAttribute('data-model'), true);
      else this.updateArrows();
    }

    disconnectedCallback(){
      if (this._onClick) this.removeEventListener('click', this._onClick);
      if (this.$track && this._onScroll) this.$track.removeEventListener('scroll', this._onScroll);
    }

    applyFilter(model, noScrollReset){
      if (!model) return;
      for (var i=0;i<this.$tabs.length;i++){
        var on = this.$tabs[i].getAttribute('data-model') === model;
        this.$tabs[i].classList.toggle('is-active', on);
        this.$tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      this.$cards.forEach(function(card){
        var models = (card.getAttribute('data-models') || '').split(/\s+/).filter(Boolean);
        card.hidden = models.indexOf(model) === -1;
      });
      // per-tab "Pinned products" (data-pin="slug:rank ..."): pinned cards first in rank order,
      // the rest keep collection order. Re-appending moves nodes, so DOM/tab order matches too.
      if (this.$track){
        var rank = function(card){
          var pins = (card.getAttribute('data-pin') || '').split(/\s+/);
          for (var k=0;k<pins.length;k++){
            var cut = pins[k].lastIndexOf(':');
            if (cut > 0 && pins[k].slice(0, cut) === model) return parseInt(pins[k].slice(cut + 1), 10);
          }
          return Infinity;
        };
        var track = this.$track;
        this.$cards.slice().sort(function(a, b){
          var ra = rank(a), rb = rank(b);
          if (ra !== rb) return ra < rb ? -1 : 1;
          return a._accIdx - b._accIdx;
        }).forEach(function(c){ track.appendChild(c); });
      }
      if (this.$track) this.$track.classList.toggle('is-empty', !this.$cards.some(function(c){ return !c.hidden; }));
      if (this.$track && !noScrollReset) this.$track.scrollLeft = 0;
      this.updateArrows();
    }

    // scroll the track by ~one card width (incl. gap) in `dir` (-1 prev / +1 next)
    scrollByCard(dir){
      if (!this.$track) return;
      var card = this.$cards.filter(function(c){ return !c.hidden; })[0];
      var step = card ? (card.getBoundingClientRect().width + 20) : Math.round(this.$track.clientWidth * 0.8);
      this.$track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    // disable prev at the start / next at the end (degrade cleanly if arrows absent)
    updateArrows(){
      if (!this.$track || !this.$arrows.length) return;
      var max = this.$track.scrollWidth - this.$track.clientWidth - 1;
      var x = this.$track.scrollLeft;
      this.$arrows.forEach(function(a){
        var prev = a.getAttribute('data-dir') === 'prev';
        var off = prev ? (x <= 1) : (x >= max);
        if (off) a.setAttribute('disabled', ''); else a.removeAttribute('disabled');
      });
    }
  });
})();

/* ── campaign-countdown custom element (Phase 4 Task 4.2) ────────────────────
   Parses data-end (ISO 8601), ticks every 1000ms, writes days/hours/mins/secs
   into the [data-unit] .cd-num nodes + the .cd-clock mirror (live seconds, test
   hook). Clears the interval on expiry (≤0) and on disconnect. Bad/missing
   data-end leaves the static zeros. */
(function(){
  if (typeof window === 'undefined' || !window.customElements) return;
  if (customElements.get('campaign-countdown')) return;   // double-define guard

  function pad(n){ return (n < 10 ? '0' : '') + n; }

  customElements.define('campaign-countdown', class extends HTMLElement {
    connectedCallback(){
      if (this._init) return;
      // campaign.js loads from <head>, so this element can upgrade & fire
      // connectedCallback BEFORE its child subtree (.cd-clock + [data-unit] boxes)
      // is parsed. Defer init until the unit nodes exist, otherwise we'd cache an
      // empty $units/$clock and tick into nothing (boxes stay at the static 0s).
      if (!this.querySelector('[data-unit]') || !this.querySelector('.cd-clock')){
        var selfDefer = this;
        // isConnected: if the element was removed while waiting (theme editor reload),
        // a late re-init would bind listeners/timers on a zombie node after its
        // disconnectedCallback already ran.
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ if (selfDefer.isConnected) selfDefer.connectedCallback(); }, { once: true });
        else setTimeout(function(){ if (selfDefer.isConnected) selfDefer.connectedCallback(); }, 0);
        return;
      }
      this._init = true;

      // unit nodes by [data-unit]; .cd-num within each (fall back to the unit itself)
      this.$units = {};
      var unitEls = this.querySelectorAll('[data-unit]');
      for (var i=0;i<unitEls.length;i++){
        var u = unitEls[i].getAttribute('data-unit');
        this.$units[u] = unitEls[i].querySelector('.cd-num') || unitEls[i];
      }
      this.$clock = this.querySelector('.cd-clock');

      // parse the end timestamp (runs in the browser; new Date is fine here).
      // Guard a missing/invalid value: leave the static zeros, don't tick/throw.
      var raw = this.getAttribute('data-end');
      var end = raw ? new Date(raw).getTime() : NaN;
      if (!raw || isNaN(end)){ return; }
      this._end = end;

      var self = this;
      this._tick = function(){ self.render(); };
      this.render();                         // paint immediately (no 1s blank)
      this._timer = setInterval(this._tick, 1000);
    }

    disconnectedCallback(){
      if (this._timer){ clearInterval(this._timer); this._timer = null; }
    }

    render(){
      var rem = this._end - Date.now();
      if (rem <= 0){
        this.setAttribute('data-ended', '');
        this.write(0, 0, 0, 0);
        if (this._timer){ clearInterval(this._timer); this._timer = null; }
        return;
      }
      var s = Math.floor(rem / 1000);
      var days  = Math.floor(s / 86400);
      var hours = Math.floor((s % 86400) / 3600);
      var mins  = Math.floor((s % 3600) / 60);
      var secs  = s % 60;
      this.write(days, hours, mins, secs);
    }

    write(days, hours, mins, secs){
      if (this.$units.days)  this.$units.days.textContent  = String(days);
      if (this.$units.hours) this.$units.hours.textContent = pad(hours);
      if (this.$units.mins)  this.$units.mins.textContent  = pad(mins);
      if (this.$units.secs)  this.$units.secs.textContent  = pad(secs);
      // .cd-clock = live seconds string (test hook; changes every tick)
      if (this.$clock) this.$clock.textContent = String(secs);
    }
  });
})();

/* ── campaign-series-nav custom element (Phase 4 Task 4.3) ───────────────────
   Sticky pill nav. Pill clicks preventDefault + smooth-scroll to
   document.getElementById(anchor); a pill whose anchor has no matching element
   no-ops (no throw, no navigation). An IntersectionObserver marks the pill whose
   target is currently in view with .is-active (nice-to-have; degrades cleanly).
   Pill-click scrolls compute the rest-state obstruction (pinned bar + header when
   it stays visible) instead of trusting the targets' static scroll-margin-top:
   that 120px was sized for pin-BELOW-header mode, so in pin-hides-header mode it
   over-shot by ~65px and left a strip of the PREVIOUS product row visible under
   the pinned bar (Bill 2026-07-03). scroll-margin-top still serves native URL-hash
   jumps, where the header is visible and 120px is about right. */
(function(){
  if (typeof window === 'undefined' || !window.customElements) return;
  if (customElements.get('campaign-series-nav')) return;   // double-define guard

  customElements.define('campaign-series-nav', class extends HTMLElement {
    connectedCallback(){
      if (this._init) return;
      var self = this;
      // campaign.js loads from <head>, so this element can upgrade before its pill
      // subtree is parsed. Defer until at least one .snav-pill exists.
      if (!this.querySelector('.snav-pill')){
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ self.connectedCallback(); }, { once: true });
        else setTimeout(function(){ self.connectedCallback(); }, 0);
        return;
      }
      this._init = true;

      this.$pills = Array.prototype.slice.call(this.querySelectorAll('.snav-pill'));

      // pill clicks → smooth-scroll to the anchored element; no-op when absent.
      this.addEventListener('click', function(ev){
        var pill = ev.target.closest && ev.target.closest('.snav-pill');
        if (!pill || !self.contains(pill)) return;
        ev.preventDefault();   // keep the page put; we drive the scroll ourselves
        var anchor = pill.getAttribute('data-anchor') || '';
        if (!anchor) return;
        var el = document.getElementById(anchor);
        if (!el) return;       // ghost pill (no target) → no-op
        self._scrollToAnchor(el, 'smooth');
        self._settleAnchor(anchor);
      });

      // ── active-pill highlight (nice-to-have) ──
      // Mark the pill whose target is currently the topmost in view. Guard for
      // IntersectionObserver support; skip cleanly when unavailable.
      this._setupActive();

      // ── JS-sticky pin (Phase 5 Task A) ──
      // Pin the bar with position:fixed below the theme's own sticky header once the
      // bar's natural document top scrolls up to the header height. CSS sticky can't do
      // this here because the theme wraps each section in its own short .shopify-section
      // (it un-sticks the moment that wrapper scrolls past).
      this._setupSticky();
    }

    disconnectedCallback(){
      if (this._io){ try { this._io.disconnect(); } catch(e){} this._io = null; }
      this._teardownSticky();
    }

    // ── sticky pin helpers ─────────────────────────────────────────────────
    _setupSticky(){
      // Honor the section's `sticky` checkbox; default ON when the attr is absent.
      var stickyAttr = this.getAttribute('data-sticky');
      if (stickyAttr === 'false') return;
      var self = this;
      // Opt-in immersive pin: when 'true' the bar pins at the very top (top:0) and slides
      // the theme's global header away. Default (attr absent or 'false') keeps the EXISTING
      // behavior — pin just below the header — which the dev-page standalone nav relies on.
      this._hideHeader = this.getAttribute('data-pin-hides-header') === 'true';
      this._headerHidden = false;
      this._offsetTop = parseInt(this.getAttribute('data-offset-top'), 10) || 0;
      this._pinned = false;
      this._spacer = null;
      this._rafQueued = false;

      this._onScroll = function(){
        if (self._rafQueued) return;
        self._rafQueued = true;
        (window.requestAnimationFrame || function(cb){ return setTimeout(cb, 16); })(function(){
          self._rafQueued = false;
          self._syncPin();
        });
      };
      this._onResizeSticky = function(){
        // header height / bar height can change with width → recompute, then re-sync.
        self._syncPin();
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResizeSticky);
      this._syncPin();   // initial state (e.g. loaded already-scrolled / anchor jump)
    }

    _teardownSticky(){
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._onResizeSticky) window.removeEventListener('resize', this._onResizeSticky);
      this._onScroll = null; this._onResizeSticky = null;
      this._unpin();
      this._restoreThemeHeader();   // ensure the header is never left hidden on disconnect
    }

    // Height of the theme's own sticky/fixed header at runtime (+ the offset_top tweak).
    // Prefer the theme header selector found on this store (#shopify-section-header, a
    // position:sticky wrapper, z-index 4); fall back to scanning top-of-page elements
    // whose computed position is fixed/sticky and that span most of the viewport width.
    _themeHeaderHeight(){
      var h = 0;
      var hdr = document.getElementById('shopify-section-header');
      if (hdr){
        var cs = window.getComputedStyle(hdr);
        if (cs.position === 'sticky' || cs.position === 'fixed'){
          h = hdr.getBoundingClientRect().height;
        }
      }
      if (!h){
        // fallback: topmost wide fixed/sticky element (ignore this bar itself)
        var best = 0;
        var els = document.querySelectorAll('header, [class*="header"], [id*="header"]');
        for (var i=0;i<els.length;i++){
          var el = els[i];
          if (el === this || this.contains(el)) continue;
          var c = window.getComputedStyle(el);
          if (c.position !== 'fixed' && c.position !== 'sticky') continue;
          var r = el.getBoundingClientRect();
          if (r.top <= 1 && r.height > 20 && r.height < 300 && r.width > window.innerWidth * 0.5){
            if (r.height > best) best = r.height;
          }
        }
        h = best;
      }
      return Math.round(h) + (this._offsetTop || 0);
    }

    _syncPin(){
      if (!this.isConnected) return;
      var headerH = this._themeHeaderHeight();
      // In hide-header mode the bar pins at the very top (the header slides away), so the
      // threshold is "bar's natural top reaches 0"; otherwise it's "reaches the header height".
      var pinTop = this._hideHeader ? 0 : headerH;
      var pinZ = this._hideHeader ? this._pinnedZ() : this._headerZ();
      // Natural document top of the bar. When pinned the bar is out of flow, so use the
      // spacer's position (it occupies the bar's old slot) to compute the true threshold.
      var ref = this._pinned && this._spacer ? this._spacer : this;
      var docTop = ref.getBoundingClientRect().top + window.pageYOffset;
      var y = window.pageYOffset;
      // hide-header mode is two-stage so the pin feels natural: slide the global header away the
      // moment the bar reaches the header's BOTTOM edge (so the bar never scrolls UNDER the header
      // before pinning), then pin at top:0 once the bar's top reaches the viewport top. Non-hide
      // mode keeps the single threshold (pin just below the still-visible header).
      if (this._hideHeader){
        // slide the global header up in LOCKSTEP with scroll across the [header-bottom → top] band
        // (no CSS transition → tracks the finger exactly, no lag/residue). 0 at the header's bottom
        // edge, full headerH (off-screen) by the time the bar reaches the viewport top.
        this._setHeaderSlide(Math.max(0, Math.min(headerH, y - (docTop - headerH))));
      }
      var shouldPin = (y >= (docTop - (this._hideHeader ? 0 : headerH)));

      if (shouldPin && !this._pinned){
        this._pin(pinTop, pinZ);
      } else if (!shouldPin && this._pinned){
        this._unpin();
      } else if (this._pinned){
        // keep top/width current as the header height / layout changes while pinned
        this.style.top = pinTop + 'px';
        this.style.zIndex = String(pinZ);
        if (this._spacer) this._spacer.style.height = this._barHeight() + 'px';
      }
    }

    _headerZ(){
      var hdr = document.getElementById('shopify-section-header');
      var z = hdr ? parseInt(window.getComputedStyle(hdr).zIndex, 10) : NaN;
      if (isNaN(z)) z = 4;            // observed theme header z-index
      return Math.max(z - 1, 1);     // sit below the header
    }

    // hide-header mode: sit ABOVE the theme header (it's sliding away behind us)
    _pinnedZ(){
      var hdr = document.getElementById('shopify-section-header');
      var z = hdr ? parseInt(window.getComputedStyle(hdr).zIndex, 10) : NaN;
      if (isNaN(z)) z = 4;            // observed theme header z-index
      return z + 1;                  // sit above the header
    }

    // Move the theme's global header up by `px` (0 = fully shown, headerH = fully off-screen),
    // tied to scroll position with NO transition so it tracks the finger exactly. A timed
    // transition lags behind fast scrolling and leaves a visible sliver/residue at the top
    // (root-caused 2026-06-30). transform → no reflow → no content jump. Safe when header absent.
    _setHeaderSlide(px){
      if (!this._hideHeader) return;
      var hdr = document.getElementById('shopify-section-header');
      if (!hdr) return;
      if (px > 0){
        hdr.style.transition = 'none';
        hdr.style.transform = 'translateY(' + (-Math.round(px)) + 'px)';
        this._headerHidden = true;
      } else if (this._headerHidden){
        hdr.style.transform = '';
        hdr.style.transition = '';
        this._headerHidden = false;
      }
    }

    // Slide the theme header back in. Idempotent; keeps the transition so it eases back.
    _restoreThemeHeader(){
      if (!this._headerHidden) return;
      var hdr = document.getElementById('shopify-section-header');
      if (hdr) hdr.style.transform = '';
      this._headerHidden = false;
    }

    _barHeight(){
      // measured BEFORE going fixed (in normal flow) so it equals the spacer size.
      return Math.round(this.getBoundingClientRect().height) || 0;
    }

    _anchorTop(el){
      var sticky = this.getAttribute('data-sticky') !== 'false';
      var hideHdr = sticky && this.getAttribute('data-pin-hides-header') === 'true';
      var obstruction = (sticky ? this._barHeight() : 0) + (hideHdr ? 0 : this._themeHeaderHeight()) + 12;
      return Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - obstruction);
    }

    _scrollToAnchor(el, behavior){
      window.scrollTo({ top: this._anchorTop(el), behavior: behavior });
    }

    _settleAnchor(anchor){
      var self = this;
      var token = (this._anchorSettleToken || 0) + 1;
      this._anchorSettleToken = token;
      var correct = function(){
        if (self._anchorSettleToken !== token) return;
        var target = document.getElementById(anchor);
        if (!target) return;
        var top = self._anchorTop(target);
        // correct with 'smooth', never 'auto': an 'auto' jump visibly teleports, and if the
        // click's own smooth scroll is still in flight it CANCELS that animation ('smooth'
        // re-targets the ongoing glide instead). 2026-07-10 audit MAJOR.
        if (Math.abs(window.pageYOffset - top) > 4) window.scrollTo({ top: top, behavior: 'smooth' });
      };
      // NO immediate rAF correction (2026-07-10 audit MAJOR): one frame after
      // scrollTo(smooth) the page hasn't arrived yet, so |pageYOffset - top| > 4 was
      // ~always true and the 'auto' correction turned EVERY pill click into an instant
      // jump. 700ms lets the initial glide finish (or nearly) before fixing drift from
      // lazy media/layout; the load listener covers late images.
      window.setTimeout(correct, 700);
      if (document.readyState === 'loading') window.addEventListener('load', correct, { once: true });
    }

    _pin(pinTop, pinZ){
      var h = this._barHeight();
      // spacer preserves the bar's slot in flow so content below doesn't jump up.
      if (!this._spacer){
        this._spacer = document.createElement('div');
        this._spacer.className = 'snav-spacer';
        this._spacer.setAttribute('aria-hidden', 'true');
      }
      this._spacer.style.height = h + 'px';
      if (this.parentNode && !this._spacer.parentNode){
        this.parentNode.insertBefore(this._spacer, this);
      }
      this.classList.add('is-pinned');
      this.style.top = pinTop + 'px';
      this.style.zIndex = String(pinZ);
      this._pinned = true;
      // (header hide/restore is driven by _syncPin's two-stage threshold, not here)
    }

    _unpin(){
      this.classList.remove('is-pinned');
      this.style.top = '';
      this.style.zIndex = '';
      if (this._spacer && this._spacer.parentNode){
        this._spacer.parentNode.removeChild(this._spacer);
      }
      this._pinned = false;
      // (header restore is driven by _syncPin's two-stage threshold + _teardownSticky)
    }

    _setupActive(){
      if (typeof window.IntersectionObserver !== 'function') return;
      var self = this;
      // map anchor id → pill, and collect existing target elements
      this._pillByAnchor = {};
      var targets = [];
      this.$pills.forEach(function(pill){
        var a = pill.getAttribute('data-anchor') || '';
        if (!a) return;
        self._pillByAnchor[a] = pill;
        var el = document.getElementById(a);
        if (el) targets.push(el);
      });
      if (!targets.length) return;
      this._io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting) return;
          var pill = self._pillByAnchor[entry.target.id];
          if (!pill) return;
          self.$pills.forEach(function(p){ p.classList.toggle('is-active', p === pill); });
        });
      }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
      targets.forEach(function(t){ self._io.observe(t); });
    }
  });
})();
